module.exports = __webpack_public_path__ + "img/logo_circle_dark.89bf3fe4.svg";